
































import Vue from "vue";
import MainColumns from "@/components/templates/MainColumns.vue";
import Notifications from "@/components/organisms/Notifications.vue";
import WizardConnect from "@/components/organisms/wizard/WizardConnect.vue";
import VaButton from "@/components/atoms/VaButton.vue";
import { DeviceConfiguration } from "@/models/deviceConfiguration";
import wizardService from "@/services/wizardService";
import StepComplete from "@/components/organisms/wizard/StepComplete.vue";
import VaNotification from "@/components/molecules/VaNotification.vue";

export default Vue.extend({
  name: "registerDevice",
  data() {
    return {
      deviceConfiguration: undefined as DeviceConfiguration | undefined,
      success: false,
      error: false,
      isLoading: false,
    };
  },
  components: {
    WizardConnect,
    VaButton,
    Notifications,
    MainColumns,
    StepComplete,
    VaNotification,
  },
  watch: {
    deviceConfiguration: async function (newVal) {
      if (newVal) this.onSave(newVal);
    },
  },
  methods: {
    async onSave(configuration: DeviceConfiguration): Promise<void> {
      try {
        this.isLoading = true;
        const lic = await this.$store.dispatch("license/addLicense", {
          licenseKey: configuration.clientConfig.serial,
        });
        if (lic) {
          await wizardService.registrationComplete(configuration);
          this.success = true;
          this.error = false;
        } else {
          this.error = true;
        }
      } catch (e) {
        this.error = true;
        this.$store.commit("notifications/displayNotification", {
          message: e.response?.data.message ? e.response?.data.message : e,
          type: "error",
        });
      } finally {
        this.isLoading = false;
      }
    },
  },
});
